<template>
  <CRow class="member_plans">
    <CCol col="12">
      <CCard>
        <CCardBody>
          <!-- ======= Pricing Section ======= -->
          <section id="pricing" class="pricing section-bg">
            <div class="container">
              <div class="section-title">
                <h2>{{ $t('Package') }}</h2>
                <p>{{ $t('PackageDescription') }}</p>
              </div>
              <div
                v-if="isFetching"
                class="d-flex justify-content-center align-items-center py-5 my-5"
              >
                <a-spin size="large" />
              </div>
              <template v-else>
                <div class="row no-gutters" v-if="plans.length">
                  <template v-if="isNotTrustyCDN">
                    <PackageCard
                      v-for="plan in plans"
                      :key="plan.id"
                      :plan="plan"
                      @select="clickPlan(plan)"
                      :is-selected="selectedPlan && selectedPlan.id === plan.id"
                    />
                  </template>
                  <template v-else>
                    <div class="oem_package_grid">
                      <OemPackageCard
                        v-for="plan in plans"
                        :key="plan.id"
                        :plan="plan"
                        @select="clickPlan(plan)"
                        :is-selected="selectedPlan && selectedPlan.id === plan.id"
                      />
                    </div>
                  </template>
                </div>
                <a-card v-else class="mb-4">
                  <p class="text-center">{{ $t('message.NoMemberPackagesAvailable') }}</p>
                </a-card>
              </template>

              <div class="box">
                <h3>{{ $t('Value-addedservices') }}</h3>
                <ul role="list-items" class="list-group">
                  <li class="list-group-item d-flex align-items-center">
                    {{ $t('Accelerateddomainname') }} <span
                    class="badge badge-info badge-pill"> {{ $t('Effectivemonthly') }} </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <button data-shoppy-product="13rtGMV" class="btn badge badge-success badge-pill"> 1 /
                      ${{ domain_price }}
                    </button>&nbsp;&nbsp;
                  </li>
                  <li class="list-group-item d-flex align-items-center">
                    {{ $t('Highspeedandhighflowprevention') }}
                    <span class="badge badge-info badge-pill"> {{ $t('Effectivemonthly') }} </span>
                    <button data-shoppy-product="4tQ2kdN" class="btn badge badge-success badge-pill">
                      100GB / ${{ traffic_price * 100 }}
                    </button>&nbsp;&nbsp;
                  </li>
                </ul>
                <CRow class="text-left">
                  <CCol sm="6">
                  </CCol>
                  <CCol sm="6" class="text-right price-wrapper">
                    <span id="price"><b>{{ $t('Price') }} </b> : $  {{ order.amountPrice }}</span>
                    <CButton size='lg' color='primary' @click="clickSubmit()">
                      {{ isNotTrustyCDN ? $t('Submit') : $t('contact_us.TrustyCDNContactUsTitle') }}
                    </CButton>
                  </CCol>
                </CRow>
              </div>
            </div>
          </section><!-- End Pricing Section -->
          <!-- ======= Contact Section ======= -->
          <section id="contact" class="contact">
            <div class="container">
              <div class="section-title">
                <h2>{{ $t('ContactConsulting') }}</h2>
                <p></p>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div v-if="isVendorInfoEmpty" class="text-center w-100">
                    {{$t('contact_us.TrustyCDNContactUsContent')}}
                  </div>
                  <div v-else class="info-box-container">
                    <div class="info-box" v-if="contact.contact_tg">
                      <i class="bx bx-envelope"></i>
                      <h3>Telegram</h3>
                      <p><a :href="`https://t.me/${contact.contact_tg}`">Telegram:{{contact.contact_tg}}</a></p>
                    </div>
                    <div class="info-box" v-if="contact.contact_email">
                      <i class="bx bx-envelope"></i>
                      <h3>Email</h3>
                      <p>
                        <a :href="`mailto:${contact.contact_email}`">Email: {{ contact.contact_email }}</a>
                      </p>
                    </div>
                    <div class="info-box" v-if="contact.contact_phone">
                      <i class="bx bx-phone"></i>
                      <h3>{{ $t('contact_us.ContactPhoneLabel') }}</h3>
                      <p><a :href="`tel:${contact.contact_phone}`">Phone: {{ contact.contact_phone }}</a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section><!-- End Contact Section -->
          <!--<div class="embed-responsive embed-responsive-4by3" style="height:1600px">
            <iframe class="embed-responsive-item" :src="planSrc" ref="iframe" allowfullscreen></iframe>
          </div>-->
          <!-- <CModal :title="$t('checkout.CheckoutConfirmation')"
                  :show.sync="showCheckoutModal"
                  :closeOnBackdrop="false">
            <CRow>
              <CCol col="6">
                <label class="text-value">
                  {{ $t('checkout.CNAME') }}
                </label>
                <p>{{ checkout.cname }}</p>
              </CCol>

              <CCol col="6">
                <label class="text-value">
                  {{ $t('checkout.PlanName') }}
                </label>
                <p>{{ selectedPlan.name }}</p>
              </CCol>

              <CCol col="6">
                <label class="text-value">
                  {{ $t('checkout.AdditionalDomainNumber') }}
                </label>
                <p>{{ additionalDomainNumber }}</p>
              </CCol>

              <CCol col="6">
                <label class="text-value">
                  {{ $t('checkout.AdditionalTraffic') }}
                </label>
                <p>{{ checkout.additional_traffic }}</p>
              </CCol>

              <CCol col="6">
              </CCol>
              <CCol col="6">
                <label class="text-value">
                  {{ $t('checkout.TotalPrice') }}
                </label>
                <p>{{ checkout.amount_currency1 }} USDT</p>
              </CCol>

              <CCol col="12">
               <p>{{ $t('checkout.CheckoutConfirmation') }}</p>
              </CCol>
            </CRow>

            <template v-slot:footer>
              <button
                type="button"
                class="btn btn-primary"
                @click="clickConfirm()">
                {{ $t('Pay') }}
              </button>
            </template>
          </CModal> -->
          <PaymentCheckout
            :order="order"
            @hide="paymentShow=false"
            :paymentShow.sync="paymentShow"
            id="paymentcheckout"
          />
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<style scoped>
.info-box-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items:  center;
  gap: 1rem;
}
.info-box-container .info-box {
  padding: 1rem;
  margin: 0;
  border-radius: 4px;
}
</style>

<script>
import 'boxicons'
import 'boxicons/css/boxicons.min.css'
import 'remixicon/fonts/remixicon.css'

import axios from '@/plugins/axios'
import numeral from 'numeral';
import { listPlan, listTrustyPlan } from '@/utilities/api'
import Price, { OEMPrice } from '@/utilities/price'
import { mapGetters } from "vuex";
import { EventBus } from "@/plugins/event-bus";
import { ContactUsMixin } from "@/mixins/ContactUsMixin";


export default {
  name: "MemberPlans",
  components: {
    OemPackageCard: () => import('./components/OemPackageCard.vue'),
    PackageCard: () => import('./components/PackageCard.vue'),
    PaymentCheckout: () => import('../payment/Checkout.vue'),
  },
  mixins: [ContactUsMixin],
  data() {
    return {
      isFetching: true,
      order: {
        amountPrice: 0,
        type: "plan",
        plan: null,
        additional_domain_number: 0,
        additional_traffic: 0
      },
      
      paymentShow: false,
      plans: [],
      showCheckoutModal: false,
      selectedPlan: null,
      selectedCoin: null,
      additionalDomainNumber: 0,
      additionalTrafficNumber: 0,
      isAdditionalModify: false,
      selectedPaymentType: null,
      checkout: {
        cname: null,
        additional_domain_number: 0,
        additional_traffic: 0,
        amount_currency1: 0,
        plan: {
          name: null
        }
      }
    };
  },
  computed: {
    ...mapGetters(["isNotTrustyCDN", "cname", "authInfo", "vendorInfo"]),
    price() {
      return this.isNotTrustyCDN ? Price : OEMPrice
    },
    domain_price() {
      return this.price?.DOMAIN_PRICE
    },
    traffic_price() {
      return this.price?.TRAFFIC_PRICE
    }
  },
  mounted() {
    this.fetchPlan()
  },
  watch: {
    additionalDomainNumber() {
      this.order.amountPrice = 0;
      if (this.selectedPlan) {
        this.order.amountPrice = this.selectedPlan.price.quantity;
        this.order.additional_domain_number = this.additionalDomainNumber;
        this.order.amountPrice += (this.additionalDomainNumber * Price.DOMAIN_PRICE);
        if (this.additionalTrafficNumber) {
          this.order.additional_traffic = this.additionalTrafficNumber + 'GB';
          const add_traffic = numeral(this.order.additional_traffic);
          const constanta = numeral('1GB');
          this.order.amountPrice += (add_traffic.value() / constanta.value()) * Price.TRAFFIC_PRICE;
        }
        this.order.amountPrice = this.order.amountPrice.toFixed(2);
      }
    },
    additionalTrafficNumber() {
      this.order.amountPrice = 0;
      if (this.selectedPlan) {
        this.order.amountPrice = this.selectedPlan.price.quantity;
        if (this.additionalTrafficNumber != 0 && this.additionalTrafficNumber < 100) {
          this.isAdditionalModify = true;
          return;
        }
        this.isAdditionalModify = false;
        if (this.additionalTrafficNumber > 0) {
          this.order.additional_traffic = this.additionalTrafficNumber + 'GB';
        } else {
          this.order.additional_traffic = '0GB';
        }
        const add_traffic = numeral(this.order.additional_traffic);
        const constanta = numeral('1GB');
        this.order.amountPrice += (add_traffic.value() / constanta.value()) * Price.TRAFFIC_PRICE;
        if (this.additionalDomainNumber) {
          this.order.additional_domain_number = this.additionalDomainNumber;
          this.order.amountPrice += (this.additionalDomainNumber * Price.DOMAIN_PRICE);
        }
        this.order.amountPrice = this.order.amountPrice.toFixed(2);
      }
    }
  },
  methods: {
    fetchPlan() {
      let promise;
      if (this.isNotTrustyCDN) {
        promise = listPlan()
      } else {
        promise = listTrustyPlan(this.cname)
      }
      promise.then(response => {
        this.plans = response.data

        this.plans = this.plans.filter(function (obj) {
          return obj.name !== "Prime" && obj.name !== "Booster";
        });
      }).catch((_error) => {
        this.plans = []
      }).finally(() => {
        this.isFetching = false;
      })
    },
    clickSubmit() {
      if (this.selectedPlan) {
        this.order.plan = this.selectedPlan
        if (this.order.additional_traffic === 0) {
          this.order.additional_traffic = '0GB';
        }
        if (this.isNotTrustyCDN) {
          this.paymentShow = true
        } else {
          EventBus.$emit('show-contact', {
            text: this.$t('contact_us.TrustyCDNPackageContactUsContent')
          });
        }
      } else {
        this.flash(this.$i18n.t('WarningPlanEmpty'), 'warning')
      }
    },

    clickTrial(plan) {
      axios.post('plan/subscription/trial/', {
        plan: plan.id
      }).then(() => {
        this.$router.push({ name: 'DomainList' })
      }).catch(({ errors }) => {
        errors.forEach(item => {
          this.flash(item, 'warning')
        })
      })
    },
    clickPlan(plan) {
      this.selectedPlan = plan
      this.order.amountPrice = plan.oem_price ? plan.oem_price.quantity : plan.price.quantity;
      this.additionalDomainNumber = 0
      this.additionalTrafficNumber = 0;
    },
    clickContactConsultant() {
      const el = document.querySelector('#contact')
      window.scroll({
        top: el.offsetTop,
        left: 0,
        behavior: 'smooth'
      })
    },
  },
};
</script>
